import BrainDataManagerAPI from 'dashboard/api/brain/dataManager';

const defaultConfig = () => ({
  enabled: false,
  dry_run: false,
  schedule: { frequency: 'daily', timezone: 'Asia/Jakarta' },
  monthly_run_limit: 1000,
  monthly_usage_count: 0,
  opt_out_label_ids: [],
  note_instruction: '',
  rules: [],
});

export const state = {
  config: defaultConfig(),
  activeAssistantId: null,
  fetchingAssistantId: null,
  updatingAssistantId: null,
  uiFlags: {
    fetchingItem: false,
    updatingItem: false,
  },
};

export const getters = {
  getConfig(_state) {
    return _state.config;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ state: _state, commit }, assistantId) {
    commit('setActiveAssistantId', assistantId);
    commit('setFetchingAssistantId', assistantId);
    commit('setUIFlags', { fetchingItem: true });
    try {
      const response = await BrainDataManagerAPI.get({ assistantId });
      if (_state.activeAssistantId === assistantId) {
        commit('setConfig', response.data);
      }
      return response.data;
    } finally {
      if (_state.fetchingAssistantId === assistantId) {
        commit('setFetchingAssistantId', null);
        commit('setUIFlags', { fetchingItem: false });
      }
    }
  },

  async update({ state: _state, commit }, { assistantId, ...config }) {
    commit('setUpdatingAssistantId', assistantId);
    commit('setUIFlags', { updatingItem: true });
    try {
      const response = await BrainDataManagerAPI.update({
        assistantId,
        ...config,
      });
      if (_state.activeAssistantId === assistantId) {
        commit('setConfig', response.data);
      }
      return response.data;
    } finally {
      if (_state.updatingAssistantId === assistantId) {
        commit('setUpdatingAssistantId', null);
        commit('setUIFlags', { updatingItem: false });
      }
    }
  },

  clear({ commit }) {
    commit('setActiveAssistantId', null);
    commit('setFetchingAssistantId', null);
    commit('setUpdatingAssistantId', null);
    commit('setUIFlags', { fetchingItem: false, updatingItem: false });
    commit('setConfig', defaultConfig());
  },
};

export const mutations = {
  setConfig(_state, config) {
    const currentUsageCount =
      _state.config?.monthly_usage_count ?? defaultConfig().monthly_usage_count;

    _state.config = {
      ...defaultConfig(),
      ...(config || {}),
      schedule: {
        ...defaultConfig().schedule,
        ...(config?.schedule || {}),
      },
      opt_out_label_ids: Array.isArray(config?.opt_out_label_ids)
        ? config.opt_out_label_ids
        : [],
      monthly_usage_count: config?.monthly_usage_count ?? currentUsageCount,
      rules: Array.isArray(config?.rules) ? config.rules : [],
    };
  },

  setUIFlags(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  setActiveAssistantId(_state, assistantId) {
    _state.activeAssistantId = assistantId;
  },

  setFetchingAssistantId(_state, assistantId) {
    _state.fetchingAssistantId = assistantId;
  },

  setUpdatingAssistantId(_state, assistantId) {
    _state.updatingAssistantId = assistantId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
